import React from "react";
import {labelizeUnderScoreText} from "crqlar-react-common/dist/utils/text.util";

export function GenderElement({gender}: { gender: string | undefined; }) {
    if (!gender) {
        return null;
    }

    return <>{labelizeUnderScoreText(gender)}</>;
}
